import { render } from "./PetWeightRemarkDialog.vue?vue&type=template&id=fa7a64f0"
import script from "./PetWeightRemarkDialog.vue?vue&type=script&lang=js"
export * from "./PetWeightRemarkDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__